import { render, staticRenderFns } from "./GenerateNewBox.vue?vue&type=template&id=47ec782c&scoped=true"
import script from "./GenerateNewBox.vue?vue&type=script&lang=js"
export * from "./GenerateNewBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec782c",
  null
  
)

export default component.exports